import { ChartLine } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import { CardContainer, SectionHeading } from '@/_containers';

export function Layout({
  children,
  className,
  title,
}: {
  children: React.ReactNode;
  className?: string;
  title: string;
}) {
  return (
    <CardContainer
      className={twMerge('h-full', className)}
      bodyClassName="3xl:px-4 flex h-full flex-col items-start px-4 pb-4"
      right
    >
      <div className="h-10 w-full shrink-0">
        <SectionHeading text={title} icon={ChartLine} />
      </div>
      <div className="mt-6 w-full flex-1">{children}</div>
    </CardContainer>
  );
}
